import React from 'react';

import { MAXIMUM_AMOUNT_LENGTH } from '../constants';
import VisaFxSimpleCalculatorDesktop from '../desktop/VisaFxSimpleCalculatorDesktop';
import { setAmountFrom, setAmountTo } from '../functions/calculator-functions';
import VisaFxSimpleCalculatorMobile from '../mobile/VisaFxSimpleCalculatorMobile';
import {
    Calculator,
    CalculatorFieldName,
    CurrencyDetails,
    Piwik,
    SiteCoreDictionary,
    VisaFxSimpleCalculatorProps,
} from '../types';

interface CalculatorDisplayProps {
    availableCurrencies: CurrencyDetails[];
    calculator: Calculator;
    focusedField: CalculatorFieldName | undefined;
    isMobile: boolean;
    loadingRate: boolean;
    onChangeCurrency: (currency: CurrencyDetails | undefined, field: CalculatorFieldName) => void;
    onClickMoreInfo: () => void;
    onClickSelectCurrency: (field: CalculatorFieldName) => void;
    rateError: string | undefined;
    setCalculator: (value: Calculator) => void;
    setFocusedField: (focused: CalculatorFieldName | undefined) => void;
    swapCurrencies: () => void;
    currencyOnRightSide: boolean;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const CalculatorDisplay = ({
    availableCurrencies,
    calculator,
    focusedField,
    isMobile,
    loadingRate,
    onChangeCurrency,
    onClickMoreInfo,
    onClickSelectCurrency,
    rateError,
    setCalculator,
    setFocusedField,
    swapCurrencies,
    currencyOnRightSide,
    dictionary,
    piwik,
}: CalculatorDisplayProps) => {
    const isValidAmount = (amount: number | undefined) => {
        if (typeof amount !== 'undefined') {
            if (amount.toString().length > MAXIMUM_AMOUNT_LENGTH) {
                return false;
            }
        }

        return true;
    };

    const onChangeAmountFrom = (amount: number | undefined) => {
        if (focusedField !== CalculatorFieldName.FROM) {
            return;
        }

        if (!isValidAmount(amount)) {
            return;
        }

        setAmountFrom(amount, calculator, setCalculator);
    };

    const onChangeAmountTo = (amount: number | undefined) => {
        if (focusedField !== CalculatorFieldName.TO) {
            return;
        }

        if (!isValidAmount(amount)) {
            return;
        }

        setAmountTo(amount, calculator, setCalculator);
    };

    const calculatorData: VisaFxSimpleCalculatorProps = {
        availableCurrencies,
        calculator,
        loadingRate,
        onChangeAmountFrom,
        onChangeAmountTo,
        onChangeCurrency,
        onClickMoreInfo,
        onClickSelectCurrency,
        rateError,
        setFocusedField,
        swapCurrencies,
        currencyOnRightSide,
        dictionary,
        piwik,
    };

    if (isMobile) {
        return <VisaFxSimpleCalculatorMobile {...calculatorData} />;
    }

    return <VisaFxSimpleCalculatorDesktop {...calculatorData} />;
};

export default CalculatorDisplay;
